import { lazy } from "react";

export const LoginCallbackAsync = lazy(() =>
  import("./LoginCallback").then((module) => ({ default: module.LoginCallback })),
);
